import { render, staticRenderFns } from "./CellRendererCheckbox.vue?vue&type=template&id=1088c5a5&"
import script from "./CellRendererCheckbox.vue?vue&type=script&lang=js&"
export * from "./CellRendererCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports